import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-time-clock-circle.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88m64-88a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V72a8 8 0 0 1 16 0v48h48a8 8 0 0 1 8 8" }, null, -1)])]);
}
var interface_time_clock_circle_default = { render };
//#endregion
export { interface_time_clock_circle_default as default, render };

//# sourceMappingURL=interface-time-clock-circle.svg.js.map